export const setAutoDiscounts = (autoDiscounts) => ({
    type: "SET_AUTO_DISCOUNTS",
    payload: autoDiscounts,
});
